import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectsAddComponent } from '../../shared/dialogs/projects-add/projects-add.component';
import Swal from 'sweetalert2';
import { ProjectsPromotionsAddComponent } from '../../shared/dialogs/projects-promotions-add/projects-promotions-add.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsCampaignAddComponent } from '../../shared/dialogs/projects-campaign-add/projects-campaign-add.component';
import { CampaignLogsComponent } from '../../shared/dialogs/campaign-logs/campaign-logs.component';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MainService } from 'src/app/services/main.service';
import { CampaignModel, DashboardCampaigns } from 'src/app/models/campaign.model';
import { ProjectsService } from 'src/app/services/projects.service';
import { ProjectCampListModel, ProjectCampaignModel, ProjectModel } from 'src/app/models/project.model';
import { ProjectsCampaignsLogsComponent } from '../../shared/dialogs/projects-campaigns-logs/projects-campaigns-logs.component';
import { StoreService } from 'src/app/services/store.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CutoffService } from 'src/app/services/cutoff.service';
import { ProjectExtraStoresAddComponent } from '../../shared/dialogs/project-extra-stores-add/project-extra-stores-add.component';
import { SharedArtsDiagramViewComponent } from '../../shared/dialogs/shared-arts-diagram-view/shared-arts-diagram-view.component';
@Component({
  selector: 'app-projects-view',
  templateUrl: './projects-view.component.html',
  styleUrls: ['./projects-view.component.scss']
})
export class ProjectsViewComponent implements OnInit, OnDestroy {
  campaignsData!: any;
  years: string[] = [];
  loaded : boolean = false;
  id_proy_camp : number = 0;
  project : ProjectModel = new ProjectModel();
   @ViewChildren('searchInput') searchInputs!: QueryList<ElementRef<HTMLInputElement>>;
   @ViewChildren('searchInput2') searchInputs2!: QueryList<ElementRef<HTMLInputElement>>;
  selectedColumns: string[] = [];
  displayedColumns: string[] = [];
  tieneColGuardadas: boolean = true;
  promotionFile: any = [];

  private _destroy$ = new Subject<void>();

  constructor(
    private matDialog: MatDialog,
    private campaignService: CampaignsService,
    private projectsS: ProjectsService,
    private _params: ActivatedRoute,
    private main: MainService,
    private _router: Router,
    private _storeS: StoreService,
    private _cutoffS : CutoffService
  ) {

    this.campaignsData = new ProjectCampListModel();
    this._params.params.pipe(takeUntil(this._destroy$)).subscribe(params => {
      if(params.id){
        this.loadColumns(params.id);
        this.id_proy_camp = params.id;
        //ESTO DEBE DE ESTAR EN TODAS LOS COMPONENTESD DE PROYECTOS
       this._cutoffS.checkIfSameProjectThenReplace(this.id_proy_camp);        
        this.loadCampaign();
      }else{
        this._router.navigateByUrl('/admin/dashboard');
      } 
    });
   }

  id_campana = 0;
  selectedSucursalCorte: number = 0;
  sucursalesCorte : any = [];

  ngOnInit(): void {
    this.getCorteSucursales();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  isBuho():boolean{
    return this.campaignService.isBuhoUsr();
   }

   getCorteSucursales(){
    this.main.ShowLoading();
    this._storeS.getCutoffs().subscribe(
      (result : any) => {
      this.main.HideLoading();
        this.sucursalesCorte = result.data.filter((x:any)=> x.generated == 1);
      },
      (err : any) => {
        this.main.HideLoading();
        console.log(err);
      }
    );
   }

   testFiltro(){
    let filtrotest = [{ nombre: "#Cajas", id: 30, valor : -5 , operador: 1}];

    let filtrado = this._cutoffS.filtrarSucursales(filtrotest);
    console.log(filtrado);
   }

   setSucursalesCorte(id_cutoff : number){
    Swal.fire({
      title: '¿Está seguro que desear cambiar el Corte de Sucursales de esta campaña?.',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
      .then((willDo) => {
        if (willDo.isConfirmed) {
          this.main.ShowLoading();
          this.projectsS.setCutoffProyect(this.id_campana, id_cutoff).subscribe(
            (x: any) => {
              this.main.HideLoading();
              Swal.fire({
                icon: 'success',
                title: 'Registro guardado',
                text: 'El corte se actualizó correctamente'
              });
              this.loadCampaign();
              this._cutoffS.current_project_camp_id = 0;
            },
            (err:any) => {
              this.main.HideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
              });
            }
          );    
        }else{
          this.selectedSucursalCorte = 0;
        }
      });

   }

   id_campana_proy : any =0;
  
   lsMediaS : Array<any> = [];
   selected_attributes : Array<any> = [];
   loadCampaign() {

    this.projectsS.getProjects(this.id_proy_camp).subscribe((x: any) => {
      this.main.HideLoading();
      this.campaignsData = x.data;
      this.selectedSucursalCorte = x.data.project.selected_cutoff_id;
      this.id_campana = x.data.project.id;
      this.id_campana_proy = x.data.project.id_proy_camp;
      this.selected_attributes = x.data.project.selected_attributes ? JSON.parse( x.data.project.selected_attributes) : []
      console.log(x.data.project.selected_attributes, this.selected_attributes);
     
      this.main.ShowLoading();
         this.projectsS.getMedios(this.id_proy_camp).subscribe((x: any) => {
           this.main.HideLoading();
           this.lsMediaS = x.data.medios;
                 this.campaignsData.progress.map((x:any)=>{
                x.selected_medios = x.selected_medios ? JSON.parse(x.selected_medios) : []
                x.searchTerm = ""
                x.filteredMedia = [...this.lsMediaS]
               }
              ); 
           console.log("load campana", this.id_campana, this.campaignsData, );
           this.loaded = true;
         });

         this.getAttributes();
    },
    (err:any) => {
      console.log(err);
          this.main.HideLoading();
    });
  }

    filterMedia(item: any) {
      const term = (item.searchTerm || '').toLowerCase();
    
      const selectedIds = item.selected_medios || [];
    
      const selectedMedia = this.lsMediaS.filter((u: any) =>
        selectedIds.includes(u.id)
      );
    
      const filtered = this.lsMediaS.filter((u: any) =>
        !selectedIds.includes(u.id) && u.nombre.toLowerCase().includes(term)
      );
    
      item.filteredMedia = [...selectedMedia, ...filtered];
      console.log(item);
    }

    getSelectedMedia(item: any) {
      const selectedIds = item.selected_medios || [];
      return this.lsMediaS.filter((medium: any) => selectedIds.includes(medium.id));
    }

    filterAtt() {
      const term = (this.searchTerm || '').toLowerCase();
    
      const selectedIds = this.selected_attributes || [];
    
      const selectedAtt = this.attributes.filter((u: any) =>
        selectedIds.includes(u.name)
      );
    
      const filtered = this.attributes.filter((u: any) =>
        !selectedIds.includes(u.name) && u.name.toLowerCase().includes(term)
      );
    
       this.filteredAtributes = [...selectedAtt, ...filtered];
     
    }


  clearSearch2(): void {
      this.searchTerm = '';
      this.filteredAtributes = [...this.attributes]; 
  }

  clearSearch(item: any): void {
      item.searchTerm = '';
      item.filteredMedia = [...this.lsMediaS]; 
  }

  toggleSelectAllMedia(item : any) {
    let allNotif = this.lsMediaS.map((p : any) => p.id);
    let currentNotif = item.selected_medios || [];

    if (currentNotif.length != 0) {
      item.selected_medios = [];
    } else {
      item.selected_medios = allNotif; 
    }
    this.selectMedios(item);
  }

  openEditProjectDialog() {
    this.matDialog.open(ProjectsAddComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        edit : true,
        data: this.campaignsData.project
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  deleteProjectConfirm() {
    Swal.fire({
      title: '¿Está seguro que desea eliminar este Proyecto?. Esto no se puede deshacer.',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
      .then((willDelete) => {
        if (willDelete.isConfirmed) {
          this.main.ShowLoading();
          this.projectsS.deleteProject(this.id_proy_camp).subscribe(
            (x: any) => {
              this.main.HideLoading();
              this.goToProjectList();
            },
            (err:any) => {
              this.main.HideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar',
                text: 'Ocurrió un error al eliminar el registro, por favor vuelva a intentarlo.'
              });
            }
          );    
        }
      });
  }

  onSelectOpened(index: number) {
    setTimeout(() => {
      const input = this.searchInputs.toArray()[index];
      input?.nativeElement?.focus();
    }, 0);
  }

  onSelectOpened2(index: number) {
    setTimeout(() => {
      const input = this.searchInputs2.toArray()[index];
      input?.nativeElement?.focus();
    }, 0);
  }


  selectMedios(item : any){
    this.projectsS.selectMedio(item.id, item.selected_medios).subscribe((x:any)=>{
      console.log("selected")
    });
  }

  selectAtt(){
     this.projectsS.selectAtributes( this.id_proy_camp , this.selected_attributes).subscribe((x:any)=>{
       console.log("selected")
     });
  //console.log(this.selected_attributes);
  }

  attributes : Array<any> = [];
  filteredAtributes : Array<any> = [];
  searchTerm : any = "";
   getAttributes(){
      this.main.ShowLoading();
      this._storeS.getAtributos().subscribe(
        (result : any) => {
          
        this.main.HideLoading();
          this.attributes = result.data;
          this.filteredAtributes = [...this.attributes]
        },
        (err : any) => {
          this.main.HideLoading();
          console.log(err);
        }
      );
    }

  openPromo(){
    if(!this.campaignsData.project.id_file){
     this._router.navigateByUrl('/admin/projects/promotions/' + this.campaignsData.project.id + '/' + this.campaignsData.project.folder )
        //   this.matDialog.open(ProjectsPromotionsAddComponent, {
        //   panelClass: ['dialogs-md'],
        //   data: {
        //     project: this.campaignsData.project,
        //     id_camp : this.id_proy_camp
        //   }
        // }).afterClosed().subscribe(
        //   resp => {
        //      this._router.navigateByUrl('/admin/projects/promotions/' + this.campaignsData.project.id + '/' + this.campaignsData.project.folder ).then(() => {
        //       window.location.reload();
        //     });
        //   }
        // );
    }else{
      this._router.navigateByUrl('/admin/projects/promotions/' + this.campaignsData.project.id + '/' +  this.campaignsData.project.folder).then(() => {
      });
    }

  }

  openUploadExtraSuc(){
    this.matDialog.open(ProjectExtraStoresAddComponent, {
      panelClass: ['dialogs-md'],
      data: {
        project: this.campaignsData.project
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  async openSharedArts(): Promise<void> {
    this.main.ShowLoading();
    try {
      const respuesta: any = await this.projectsS.getProjectsSlim(this.id_proy_camp).toPromise();
      const contexto = respuesta?.data || respuesta || {};
      const proyectos = contexto.proyectos || {};
      const mediosSeleccionados = new Set<number>();

      Object.values(proyectos).forEach((proyecto: any) => {
        const seleccionados = Array.isArray(proyecto.selected_medios)
          ? proyecto.selected_medios
          : JSON.parse(proyecto.selected_medios || '[]');
        seleccionados.forEach((idMedio: any) => mediosSeleccionados.add(Number(idMedio)));
      });

      this.main.HideLoading();

      this.matDialog.open(SharedArtsDiagramViewComponent, {
        panelClass: ['dialogs-xl'],
        disableClose: true,
        data: {
          projectAllDiagramations: (contexto.diagram_all || []).map((diagrama: any) => ({
            ...diagrama,
            idProyectoContexto: Number(diagrama.id_proyecto)
          })),
          projectDiagramations: contexto.diagram_all || [],
          id_proy_camp: this.id_proy_camp,
          id_proyecto_campana: this.id_proy_camp,
          selected_medios: Array.from(mediosSeleccionados),
          proyectosContexto: proyectos,
          project: this.campaignsData.project,
          campaing: this.campaignsData.project,
          phases: contexto.groupedPhases || [],
          diagram_files: []
        }
      }).afterClosed().subscribe(resultado => {
        if (resultado?.reload) this.loadCampaign();
      });
    } catch (error) {
      this.main.HideLoading();
      console.error('No fue posible cargar los artes compartidos de la campaña.', error);
      Swal.fire('Error', 'No fue posible abrir los artes compartidos de la campaña.', 'error');
    }
  }

  goToCampaign(id: number) {
    this._router.navigateByUrl('/admin/projects/config/' + id)
  }

  goToProjectList() {
    this._router.navigateByUrl('/admin/projects')
  }

  openCampaignLogs(camp: any) {
    this.matDialog.open(ProjectsCampaignsLogsComponent, {
      panelClass: ['dialogs-md'],
      data: {
        campaign: camp
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp.reload) this.loadCampaign();
      }
    );
  }

  openEditCampaignDialog(camp: any) {
    this.matDialog.open(ProjectsCampaignAddComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        edit : true,
        data: camp
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp.reload) this.loadCampaign();
      }
    );
  }

  deleteProyConfirm(campObj: ProjectCampaignModel) {
    Swal.fire({
      title: '¿Está seguro que desea eliminar este Proyecto?. Esto no se puede deshacer.',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
      .then((willDelete) => {
        if (willDelete.isConfirmed) {
          if (willDelete.isConfirmed) {
            this.main.ShowLoading();
            this.projectsS.deleteProject(campObj.id).subscribe(
              (x: any) => {
                this.main.HideLoading();
                this.loadCampaign();
              },
              (err:any) => {
                this.main.HideLoading();
                Swal.fire({
                  icon: 'error',
                  title: 'Error al eliminar',
                  text: 'Ocurrió un error al eliminar el registro, por favor vuelva a intentarlo.'
                });
              }
            );    
          }
        } 
      });
  }

  openAddProjectDialog() {
    this.matDialog.open(ProjectsCampaignAddComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        edit : false,
        id_proy_camp: this.id_proy_camp,
        //id_world: id_world
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp.reload) this.loadCampaign();
      }
    );
  }

  silenceProyecto(id_proj: number, silenced: boolean) {
    const action = silenced ? 'silenciar' : 'quitar el silencio de';
    const title = `¿Está seguro que desea ${action} este proyecto?`;

    Swal.fire({
      title: title,
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.main.ShowLoading();
        this.projectsS.silenceCampaignProject(id_proj, silenced).subscribe({
          next: (x: any) => {
            this.main.HideLoading();
            Swal.fire('¡Éxito!', 'El proyecto se ha actualizado correctamente.', 'success');
            this.loadCampaign(); // Recargamos los datos para reflejar el cambio
          },
          error: (err: any) => {
            this.main.HideLoading();
            console.error(err);
            Swal.fire('Error', 'Ocurrió un error al actualizar el proyecto.', 'error');
          }
        });
      } else {
        this.campaignsData.project.silenced = !silenced;
      }
    });
  }

  openProjectMedia(id: number): void {
    this._router.navigateByUrl('/admin/projects/project/' + id + '/media');
  }

  openProjectDiagramation(id: number, users_upload : string, phases_count : number , vobos_count : number, selected_medios : any){
    if(this.campaignsData!.project?.selected_cutoff_id&& phases_count!= 0&& vobos_count != 0 && selected_medios.length != 0 && this.campaignsData!.project?.id_file) {
       this._router.navigateByUrl('/admin/projects/project/diagramation/' + id );
    }else{
        Swal.fire({
          icon: 'warning',
          title: 'Faltan configuraciones',
          html: 
            '' +
            (!this.campaignsData!.project?.selected_cutoff_id ? "Es necesario configurar el corte de sucursales seleccionado.<br>" : "") +
            (phases_count == 0 || vobos_count == 0  ? "Es necesario configurar fases.<br>" : "") +
            (!this.campaignsData!.project?.id_file ? "Es necesario configurar un archivo de promociones.<br>" : "") +
            (selected_medios.length == 0 ? "Es necesario configurar medios seleccionados.<br>" : "")
        });
    }
   
  }


  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.campaignService.hasPermissions(key, buho, client);
  }

  loadColumns(id: number){
    this.main.ShowLoading();
    this.projectsS.getPromotionColumns(id).subscribe((x: any) => {
      this.promotionFile = x.data;
      if(this.promotionFile != undefined){
        this.displayedColumns = this.promotionFile.filter((key: string) => key && key.trim() !== '' && key.trim().toUpperCase() !== 'CODIGO PRINCIPAL');

        this.selectedColumns = x.columnas ?? [];
        this.loadingPromColumns = false
        if(this.selectedColumns.length == 0){
          this.tieneColGuardadas = false;
          this.selectedColumns = this.displayedColumns;
        }
        else{
          const coincidencias = this.selectedColumns.filter(item => this.displayedColumns.includes(item));
          this.selectedColumns = coincidencias;
        }

      }
      this.main.HideLoading(); 
    },
    (err:any) => {
      console.log(err);
    })
  }

  toggleSelectAllColumns(item : any) {
    if (this.selectedColumns.length === this.displayedColumns.length) {
      this.selectedColumns = []; // Deseleccionar todo
    } else {
      this.selectedColumns = [...this.displayedColumns]; // Seleccionar todo
    }
    this.updateColumnas();
  }

  loadingPromColumns : boolean = true;


  updateColumnas(){
    this.projectsS.setColumnasPromociones(this.id_campana,this.selectedColumns).subscribe((x:any)=>{
    });
  }

  saveColumnas(){
    this.main.ShowLoading();
    this.projectsS.setNewColumnasPromociones(this.id_campana,this.selectedColumns).subscribe((x:any)=>{
      this.main.HideLoading(); 
    });
  }

  onSelectOpenedChanged(event: boolean){
    if(this.tieneColGuardadas == false){
      this.saveColumnas();
      this.tieneColGuardadas = true;
    }
  }

  loadColumnsByUser(id: number){
    this.projectsS.getColumnsPromotionsByUser(id).subscribe((x: any) => {
      
      this.selectedColumns = x.data ?? [];
      this.loadingPromColumns = false
      if(this.selectedColumns.length == 0){
        this.tieneColGuardadas = false;
        this.selectedColumns = this.displayedColumns;
      }
      else{
        const coincidencias = this.selectedColumns.filter(item => this.displayedColumns.includes(item));
        this.selectedColumns = coincidencias;
      }
    },
    (err:any) => {
      console.log(err);
    })
  }

}
